import { CheckIcon as Check } from "@phosphor-icons/react";

// Iter 63 — per-row "Select for comparison" control (only rendered while compare mode is active).
export function CompareSelectButton({ obj, selection, compact = false }) {
  if (!obj || !selection?.active) return null;
  const selected = selection.isSelected(obj);
  const slug = obj.key.replace(/[^a-z0-9]+/gi, "-").toLowerCase();
  return (
    <button
      type="button"
      onClick={() => selection.select(obj)}
      aria-pressed={selected}
      aria-label={selected ? `Deselect ${obj.label}` : `Select ${obj.label} for comparison`}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 ml-mono text-[10px] uppercase tracking-widest border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ml-primary)] ${
        selected
          ? "bg-[var(--ml-primary)] text-white border-[var(--ml-primary)]"
          : "text-[var(--ml-text-secondary)] border-[var(--ml-border)] hover:text-[var(--ml-primary)] hover:border-[var(--ml-primary)]"
      }`}
      data-testid={`compare-select-${slug}`}
      data-selected={selected ? "true" : "false"}
    >
      {selected && <Check size={10} weight="bold" aria-hidden="true" />}
      {selected ? "Selected" : compact ? "Select" : "Select for comparison"}
    </button>
  );
}

export default CompareSelectButton;
